export default __webpack_public_path__ + "static/code-trainer-e41d5a1869e6c6cfdc0b0ef0ea6283a1.gif";